export default __webpack_public_path__ + "static/media/camera.7e82a9f0.svg";